import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * A side-profile plane descending from the logo's position (top-left, where
 * the wordmark's own little plane glyph sits) down to a landing in the
 * bottom-right of the hero. Visible immediately on mount. A short comet
 * trail (three fading, shrinking ghost copies on the same path, offset by
 * negative animation-delay) sells the motion better than the sprite alone.
 * Pure CSS, respects prefers-reduced-motion via the global rule in styles.css.
 */
@Component({
  selector: 'app-plane-flyby',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="plane-scene" aria-hidden="true">
      <svg class="plane-sprite plane-ghost-3" viewBox="-10 -20 120 60" width="42" height="21">
        <path [attr.d]="planePath" />
      </svg>
      <svg class="plane-sprite plane-ghost-2" viewBox="-10 -20 120 60" width="44" height="22">
        <path [attr.d]="planePath" />
      </svg>
      <svg class="plane-sprite plane-ghost-1" viewBox="-10 -20 120 60" width="45" height="22">
        <path [attr.d]="planePath" />
      </svg>
      <svg class="plane-sprite plane-main" viewBox="-10 -20 120 60" width="46" height="23">
        <path [attr.d]="planePath" />
      </svg>
    </div>
  `,
  styles: [
    `
      :host {
        position: absolute;
        inset: 0;
        pointer-events: none;
        overflow: hidden;
      }
      .plane-scene {
        position: absolute;
        inset: 0;
      }
      .plane-sprite {
        position: absolute;
        top: 0;
        left: 0;
        color: var(--color-saffron);
        fill: currentColor;
      }
      .plane-main {
        filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.4));
        animation: plane-land-main 15s cubic-bezier(0.45, 0, 0.55, 1) infinite;
      }
      .plane-ghost-1 {
        animation: plane-land-ghost1 15s cubic-bezier(0.45, 0, 0.55, 1) infinite;
        animation-delay: -0.35s;
      }
      .plane-ghost-2 {
        animation: plane-land-ghost2 15s cubic-bezier(0.45, 0, 0.55, 1) infinite;
        animation-delay: -0.7s;
      }
      .plane-ghost-3 {
        animation: plane-land-ghost3 15s cubic-bezier(0.45, 0, 0.55, 1) infinite;
        animation-delay: -1.05s;
      }

      @keyframes plane-land-main {
        0% {
          transform: translate(11vw, 5vh) rotate(20deg) scale(0.85);
          opacity: 0.95;
        }
        70% {
          transform: translate(58vw, 55vh) rotate(14deg) scale(1.2);
          opacity: 0.95;
        }
        92% {
          transform: translate(80vw, 78vh) rotate(9deg) scale(1.4);
          opacity: 0.95;
        }
        100% {
          transform: translate(90vw, 88vh) rotate(6deg) scale(1.5);
          opacity: 0;
        }
      }
      @keyframes plane-land-ghost1 {
        0% {
          transform: translate(11vw, 5vh) rotate(20deg) scale(0.85);
          opacity: 0.3;
        }
        70% {
          transform: translate(58vw, 55vh) rotate(14deg) scale(1.2);
          opacity: 0.3;
        }
        100% {
          transform: translate(90vw, 88vh) rotate(6deg) scale(1.5);
          opacity: 0;
        }
      }
      @keyframes plane-land-ghost2 {
        0% {
          transform: translate(11vw, 5vh) rotate(20deg) scale(0.85);
          opacity: 0.15;
        }
        70% {
          transform: translate(58vw, 55vh) rotate(14deg) scale(1.2);
          opacity: 0.15;
        }
        100% {
          transform: translate(90vw, 88vh) rotate(6deg) scale(1.5);
          opacity: 0;
        }
      }
      @keyframes plane-land-ghost3 {
        0% {
          transform: translate(11vw, 5vh) rotate(20deg) scale(0.85);
          opacity: 0.07;
        }
        70% {
          transform: translate(58vw, 55vh) rotate(14deg) scale(1.2);
          opacity: 0.07;
        }
        100% {
          transform: translate(90vw, 88vh) rotate(6deg) scale(1.5);
          opacity: 0;
        }
      }
    `,
  ],
})
export class PlaneFlyby {
  planePath =
    'M8,21 Q10,14 28,13 Q58,11 82,14 Q95,16 104,20 Q95,24 82,26 Q58,29 28,27 Q10,26 8,21 Z M18,14 L22,-10 L31,13 Z M9,22 L-6,27 L13,25 Z M46,25 L28,42 L60,27 Z';
}
